import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export const localstorage = {
  //storage: window.localStorage,
  set: function (key, value) {
    //存储
    var curTime = new Date().getTime()
    var storage = window.localStorage;
    var mydata = storage['user'] ? JSON.parse(storage['user']) : {};
    mydata[key] = value;
    mydata['time'] = curTime
    window.localStorage.setItem('user', JSON.stringify(mydata));
    return mydata;

  },
  get: function (key) {
    //读取
    var storage = window.localStorage;
    var mydata = storage['user'] ? JSON.parse(storage['user']) : {};
    var curTime = new Date().getTime()
    if (mydata.time) {
      if (curTime - mydata.time >= 86400 * 1000) {
        this.clear()
        mydata[key] = ""
      }
    }
    return mydata[key];
  },
  getAll: function () {
    //读取所有
    var storage = window.localStorage;
    var mydata = storage['user'] ? JSON.parse(storage['user']) : {};
    return mydata;
  },
  remove: function (key) {
    //移除
    var storage = window.localStorage;
    var mydata = storage['user'] ? JSON.parse(storage['user']) : {};
    delete (mydata[key]);
    window.localStorage.setItem('user', JSON.stringify(mydata));
    return mydata;
  },
  clear: function () {
    //清除对象
    var storage = window.localStorage;
    //console.log(storage, '----------storage---------');
    delete (storage['user']);
    //window.localStorage = storage;
    window.localStorage.setItem('user', JSON.stringify({}));
    return storage['user'];
  }
}

function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}
// cookie
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

export default new Vuex.Store({
  state: {
    user: {
      name: localstorage.get('name'),
      role: localstorage.get('role'),
      union: localstorage.get('union')
    }
  },
  mutations: {
    user: (state, data) => {
      localstorage.set('name', data.realname);
      localstorage.set('role', data.role);
      localstorage.set('token', data.token || '');
      localstorage.set('timestamp', data.timestamp || '');
      localstorage.set('union', data.union ? data.union : '')
      state.user = localstorage.getAll();
    },
    logout: (state, data) => {
      localstorage.clear();
      state.user = localstorage.getAll();
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js